module.exports = __webpack_public_path__ + "f0b08219de1b886b80046077fb3a3428.svg";